export { default as InfoCircleIcon } from '~icons/lucide/info';
